document.addEventListener('DOMContentLoaded', () => {
    document.querySelector('#locationFlyoutTrigger')?.addEventListener('click', (Event) => {
        // toggleLocation
        Event.stopPropagation()
        document.getElementById('toggleLocation')?.click();
    })

    const countryElem = document.querySelector('[data-cc]');

    if (countryElem) {
        const country = countryElem?.dataset.cc ?? 'de'
        const language = countryElem?.dataset.lc ?? 'de'

        let text = window.BrabusCountryResolver.get(country, language) + ' - ';
        text += (language === 'de') ? 'Deutsch' : 'English';
        countryElem.innerHTML = text;
    }


});


